import { Currency } from './Currency'
import { Account } from './Account'
export class AccountDetails {
  constructor (params = {}) {
    this.account = params.account ? new Account(params.account) : null
    this.currencies = params.currencies.map((currency) => {
      return {
        postpaid: currency.postpaid,
        balance: currency.balance,
        currency: new Currency(currency.currency)
      }
    })
  }
  serialize (editedFields) {
    var item = JSON.parse(JSON.stringify(this))
    Object.keys(editedFields).forEach(key => {
      item[key] = editedFields[key]
    })
    return {
    }
  }
}
